module.exports = __webpack_public_path__ + "static/media/26UNRWA5.969fbb26.jpg";